import { useHttp } from '@2r/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export interface IQueryResponse<TData> {
    data: TData | undefined;
    isLoading: boolean;
    primaryKey: string;
}

const guid_empty = "00000000-0000-0000-0000-000000000000";

export function useGetItem<TData>(baseApiPath: string, keyName: string) {
    const location = useParams();
    const primaryKey: string = location[keyName] ?? guid_empty;

    const http = useHttp(baseApiPath);

    const qry = useQuery({
        queryFn: () => http.get<TData>(`/getitem/${primaryKey}`) as TData,
        queryKey: [primaryKey],
    });

    return {
        data: qry.data,
        isLoading: qry.isLoading,
        primaryKey: primaryKey,
    };
}